import React, { Component } from "react";
import Uploader from "../uploader";

export default class MobileWalls extends Component {
  render() {
    return (
      <div className="relative">
        <button
          name="scroll-right"
          className="m-0 button-shadow-right scroll"
        ></button>

        <ul>
          {this.props.walls.map((wall) => (
            <li
              onClick={() => this.props.selectHandler("wall", wall)}
              style={{
                background: wall.color_code ? wall.color_code : "",
              }}
              className={
                this.props.selectedWall &&
                this.props.selectedWall.id === wall.id
                  ? "active"
                  : ""
              }
              key={"wallImage" + wall.id}
            >
              {" "}
              {wall.front_image && (
                <img src={wall.front_image} alt="cover" />
              )}{" "}
            </li>
          ))}
        </ul>
        <button
          name="scroll-left"
          className="m-0 button-shadow-left scroll"
        ></button>
        <Uploader
          selected={
            this.props.selectedWall && this.props.selectedWall.custom
              ? this.props.selectedWall
              : null
          }
          selectHandler={this.props.customSelectHandler}
          removeHandler={this.props.removeHandler}
		  decorationType={"wall"}
		  texts={this.props.texts}
        />
      </div>
    );
  }
}
